module.exports = __webpack_public_path__ + "img/Przyslanianie.bd279665.png";